import Vue from 'vue'
import App from './App.vue'
import router from './router'
import 'vant/lib/index.css'
import { Button, List, Cell, CellGroup, NavBar, Tabbar, TabbarItem, Field, Form, Dialog, Toast, Icon, Tag, Card, Col, Row } from 'vant'

Vue.use(Button).use(List).use(Cell).use(CellGroup).use(NavBar).use(Tabbar).use(TabbarItem)
Vue.use(Field).use(Form).use(Dialog).use(Toast).use(Icon).use(Tag).use(Card).use(Col).use(Row)

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
